/* istanbul ignore file */
import {getColorCssVars, getFontCssVars, type CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

const getBackInStockButtonCustomColorCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const isAddToCartButtonEnabled = styleParams.booleans.productPage_productAction;
  const isBuyNowButtonEnabled = styleParams.booleans.productPage_buyNowButtonEnabled;

  const getBackInStockButtonMainTextColorValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.colors?.productPage_actionButtontextColor;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.colors?.productPage_buyNowButtonTextColor;
    }
  };

  const getBackInStockButtonMainBackgroundColorValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.colors?.productPage_actionButtonbackgroundColor;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.colors?.productPage_buyNowButtonBackgroundColor;
    }
  };

  const getBackInStockButtonMainBorderColorValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.colors?.productPage_actionButtonborderColor;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.colors?.productPage_buyNowButtonBorderColor;
    }
  };

  return {
    ...getColorCssVars('backInStockButtonMainTextColor', getBackInStockButtonMainTextColorValue()),
    ...getColorCssVars('backInStockButtonMainBackgroundColor', getBackInStockButtonMainBackgroundColorValue()),
    ...getColorCssVars('backInStockButtonMainBorderColor', getBackInStockButtonMainBorderColorValue()),
  };
};

const getBackInStockButtonCustomFontCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const isAddToCartButtonEnabled = styleParams.booleans.productPage_productAction;
  const isBuyNowButtonEnabled = styleParams.booleans.productPage_buyNowButtonEnabled;

  const getBackInStockButtonMainTextFontValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.fonts?.productPage_actionButtontextFont;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.fonts?.productPage_buyNowButtonTextFont;
    }
  };

  return {
    ...getFontCssVars('backInStockButtonMainTextFont', getBackInStockButtonMainTextFontValue()),
  };
};

const getBackInStockButtonCustomStringCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const isAddToCartButtonEnabled = styleParams.booleans.productPage_productAction;
  const isBuyNowButtonEnabled = styleParams.booleans.productPage_buyNowButtonEnabled;

  const getBackInStockButtonMainBorderRadiusValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.strings?.productPage_actionButtoncornersRadius?.value;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.strings?.productPage_buyNowButtonCornersRadius?.value;
    }
  };

  const getBackInStockButtonMainBorderWidthValue = () => {
    if (isAddToCartButtonEnabled) {
      return styleParams.strings?.productPage_actionButtonborderSize?.value;
    }
    if (isBuyNowButtonEnabled) {
      return styleParams.strings?.productPage_buyNowButtonBorderSize?.value;
    }
  };

  const backInStockButtonMainBorderRadius = getBackInStockButtonMainBorderRadiusValue();
  const backInStockButtonMainBorderWidth = getBackInStockButtonMainBorderWidthValue();

  return {
    ...(backInStockButtonMainBorderRadius && {backInStockButtonMainBorderRadius}),
    ...(backInStockButtonMainBorderWidth && {backInStockButtonMainBorderWidth}),
    ...(isAddToCartButtonEnabled && {backInStockButtonPaddingBlockStart: '8px'}),
    ...(isAddToCartButtonEnabled && {backInStockButtonPaddingBlockEnd: '8px'}),
  };
};

export const getBackInStockButtonCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  return {
    ...getBackInStockButtonCustomColorCssVars(customCssVarsFnParams),
    ...getBackInStockButtonCustomFontCssVars(customCssVarsFnParams),
    ...getBackInStockButtonCustomStringCssVars(customCssVarsFnParams),
  };
};
